angular.module('jv.Dashboard.Upcoming.Interviews.Controller', [])
.controller('UpcomingInterviewsController',['$scope','jvDashboardAjaxService','jvContextualLoadingService', '$timeout','$filter','$sce','$rootScope','$window','jvHireUrlService',
    function($scope,jvDashboardAjaxService, jvContextualLoadingService, $timeout, $filter,$sce, $rootScope, $window,jvHireUrlService){
    //Map to store each interview info
    $scope.interviewDetails = {};
    $scope.interviewCancelled = false;

    //Array to hold interviews
    $scope.interviewInformation = [];
    $scope.showTextIcon = window.isfloatingIMWidgetLoadedForCandidate

    //Pagination configs
    $scope.requestObject = {
        page: 0,
        pageSize: 5
    };
    $scope.pageCount = 5;

    $scope.expanded = {};

    function generateSecureRandomId(prefix = 'instance') {
        const randomValue = window.crypto.getRandomValues(new Uint32Array(1))[0];
        return `${prefix}-${randomValue.toString(36)}`;
    }

    $scope.instanceId = generateSecureRandomId('instance');

    var extractTimeFromDate = function(dateObject){
        var time;
        time = dateObject.split('T')[1];
        var timeOfDay  = time.split(':')[0];
        if(timeOfDay>=12){
            time = time.split(':')[0] +':'+ time.split(':')[1]+ ' PM ';
        }else{
            time = time.split(':')[0] +':'+ time.split(':')[1]+' AM ';
        }
        return time;
    };

    $scope.getInterviewDetails = function(){
    	var settingsInfo = $scope.widgetObject.userWidgetSettings.widgetSetting;
    	$scope.hiringManagerIds = "";
        angular.forEach(settingsInfo, function(settingInfo, index) {
        	var values;
            if (settingInfo.userValues) {
                values = settingInfo.userValues;
            } else if(settingInfo.settings.defaultValues){
                values = settingInfo.settings.defaultValues;
            }
            if(values){
            	if(values[0] && angular.isObject(values[0].label) && values[0].EId){
                    values[0].value = angular.copy(values[0].EId);
                    if(values[0].label.name) {
                    	values[0].label = angular.copy(values[0].label.name);
                    }
                    /*
                     *  The API for fetching the list of hiring managers has the name returned as fullName.
                     *  We need this for the hiring manager filter in settings
                     */
                    else if(values[0].label.fullName) {
                    	values[0].label = angular.copy(values[0].label.fullName);
                    }
                    delete values[0].EId;
                }
                //Making sure UI doesnt make a call with all filter
                if($.isEmptyObject(values[0].label)){
                    values[0].label = '';
                    values[0].value = null;
                }
            }

            if (settingInfo.settings.name === "HiringManager" &&
                settingInfo.userValues &&
                settingInfo.userValues[0] &&
                settingInfo.userValues[0].value &&
                settingInfo.userValues[0].value.trim() !== "") {

                $scope.hiringManagerIds = settingInfo.userValues[0].value.trim();
            }
        });
    };

    //refresh widget callback
    $rootScope.$on('REFRESH_WIDGET', function(event,widgetData) {
        if(widgetData && ($scope.widgetObject.widgetId === widgetData.widgetId)){
        	//invalidate cache and fetch data from DB
            $scope.lastUpdated = '';
        	$scope.collapseItem();
        	$scope.interviewCancelled = false;
            $scope.getInterviewDetails();
            $scope.getJobInterviewsCount(true);
            $scope.fetchInterviewInformation(0,$scope.selectedDate,true);
        }
    });

    $scope.getInterviewDetails();

    //Used to paginate
    $scope.paginate = function(direction) {
        $scope.collapseItem();
        jvContextualLoadingService.show($scope.widgetObject.widgetId);
        $scope.requestObject.page = (direction === 'next') ? ($scope.requestObject.page + 1) : ($scope.requestObject.page - 1);
        if( ($scope.requestObject.page < 0) ){
            $scope.requestObject.page = 0;
            return false;
        }

        if( $scope.requestObject.page >= Math.ceil($scope.resultCount/$scope.requestObject.pageSize) ){
            $scope.requestObject.page = Math.ceil($scope.resultCount/$scope.requestObject.pageSize) -1;
            return false;
        }
        $scope.fetchInterviewInformation($scope.requestObject.page,$scope.selectedDate);
    };

    var managePaginationArrows = function(resultCount){
        if ($scope.requestObject.page === 0 || !$scope.requestObject.page) {
            $scope.disablePrev = true;
        } else {
            $scope.disablePrev = false;
        }
        if ((($scope.requestObject.page + 1) * $scope.pageCount >= resultCount) || (!resultCount)) {
            $scope.disableNext = true;
        } else {
            $scope.disableNext = false;
        }
    };

    $scope.fetchInterviewInformation = function(page, selectedDate, refresh){
        var postData;
        if(page == 'more'){
            $scope.requestObject.page++;
        }
        postData = {
                'page': $scope.requestObject.page,
                'selectedDate':selectedDate,
                'pageSize': $scope.requestObject.pageSize
        };
        //send refresh=true to get data from DB
        if(refresh){
            postData.refresh = true;
        }
        if($scope.hiringManagerIds !== "") {
        	postData.hiringManagerIds = $scope.hiringManagerIds;
        }
        jvContextualLoadingService.show($scope.widgetObject.widgetId);
        jvDashboardAjaxService.fetchUpcomingInterviews(postData,function(response){
            $scope.interviewInformation = [];
            $scope.interviewsCount = response.count;
            $scope.resultCount  = response.count;
            managePaginationArrows(response.count);
            if(response && response.interviewInfo){
                jvContextualLoadingService.hide($scope.widgetObject.widgetId);
                if(!response.count){
                    return;
                }
                $scope.interviewInformation = response.interviewInfo;
            }
        });
    };

    $scope.getJobInterviewsCount = function(refresh){
        var startDate  = $filter('date')($scope.dates[0].fullDate, 'yyyy-MM-dd');
        var endDate =  $filter('date')($scope.dates[$scope.dates.length-1].fullDate, 'yyyy-MM-dd');
        var args = {
            startDate: startDate,
            endDate: endDate
        };
      //send refresh=true to get data from DB
        if(refresh){
            args.refresh = true;
        }
        if($scope.hiringManagerIds !== "") {
        	args.hiringManagerIds = $scope.hiringManagerIds;
        }
        jvContextualLoadingService.show($scope.widgetObject.widgetId);
        jvDashboardAjaxService.getJobInterviewsCount(args,function(response){
            jvContextualLoadingService.hide($scope.widgetObject.widgetId);
            $scope.lastUpdated = response.lastUpdated;
            /* Emptying out date.data. Back-end only returns the count for dates that do have interviews.
            We need to make sure the count is reset before setting the new count for particular dates*/
            angular.forEach($scope.dates,function(date,key){
            	date.data = {};
            });
            if(response && response.datecount && response.datecount.length){
                    $scope.datesWithInterviews = response.datecount;
                    angular.forEach(response.datecount,function(dateObj,index){
                         angular.forEach($scope.dates,function(date,key){
                                var dateWithInterviews = dateObj.interviewDateISO8601.split('T')[0];
                                var calendarDate =  $filter('date')(date.fullDate, 'yyyy-MM-dd');
                                if( dateWithInterviews === calendarDate){
                                        date.data = {
                                            count: dateObj.count
                                        };
                                }
                         });
                });
            }

        });

    };

    //Checks if an item exists in an array
    var contains = function(item,arr){
            var len = arr.length;
            for(var i=0 ; i<len; i++){
                var date = item.getDate();
                var month = item.getMonth();
                var year = item.getFullYear();
                if( ( date == arr[i].date) && (month == arr[i].month) && (year === arr[i].year) ){
                    return true;
                }
            }
            return false;
    };

    var fetchTodayInUsersTimeZone = function() {
        var d = new Date();
        var dateInTime = d.getTime();
        var userTimeZone = _jvselfUser.locale.timezone;
        var momentObject = moment.tz(dateInTime,userTimeZone).format();
        var localDate = momentObject.split('T')[0];
        localDate = localDate.split('-')[2];
        d.setDate(localDate);
        return d;
    };

    var fetchTodaysInterviews = function(){
         //set selected date to today to fetch interviewinformation
        $scope.selectedDate = $filter('date')($scope.today, 'yyyy-MM-dd');
        $scope.fetchInterviewInformation($scope.requestObject.page,$scope.selectedDate);
    };

    $scope.$watch('dates',function(newVal, oldVal){
        if(newVal && newVal.length && !oldVal){
            $scope.getJobInterviewsCount();

            //fetch user timezone
            var today = fetchTodayInUsersTimeZone();
            $scope.today = angular.copy(today);
            fetchTodaysInterviews();
        }else{
            $scope.interviewInformation = [];
        }
    });

        // Added a watch to check if the isfloatingIMWidgetLoaded is true
            // if the JVIM widget is loaded then enable the IM icons
            $scope.$watch(
                function () {
                    if($window.isfloatingIMWidgetLoaded && !$scope.isfloatingIMWidgetLoaded) {
                        $scope.isfloatingIMWidgetLoaded = $window.isfloatingIMWidgetLoaded;
                        $timeout(function(){
                            $scope.$apply();
                        });
                    }
                }
            );

        $scope.openJVIMWidget = function(candidateEId){
                jvHireUrlService.openJVIMFloatingWidget(candidateEId, window._jvselfUser.email);
            };
    //Callback that gets fired when you paginate the calendar
    $scope.paginateCallback = function(newDatesArray){
        if (contains($scope.today,newDatesArray)){
            fetchTodaysInterviews();
        }
        //close any open interview details before you paginate
        $scope.collapseItem();
        //set interviewsCount to null when you paginate as we dont know which days interviews to pull
        $scope.interviewsCount = null;

        $scope.dates = newDatesArray;
        //$scope.interviewInformation = [];
        $scope.getJobInterviewsCount();
    };

    //Get details for an interview
    $scope.getInterviewDetail = function(interviewEId,applicationEId,index,groupId){
            if(!$scope.expanded[index]){
                $scope.expanded[$scope.currentIndex] = false;
                $scope.currentIndex = index;
                $scope.currentInterviewEId = interviewEId;
                var args = {
                    'groupId': groupId,
                    params: {
                        'applicationEId': applicationEId,
                        'interviewEId': interviewEId
                    }
                };
                jvContextualLoadingService.show($scope.widgetObject.widgetId);
                jvDashboardAjaxService.getInterviewDetail(args,function(response){
                	 if(response && response.interview){
                         //converting times to date object as BE sends date in non-iso format
                     	if(response.interview.length) {
                     		$scope.interviewCancelled = false;
                     		 angular.forEach(response.interview ,function(value,key){
                                  var profilePicUrl = '/admin/action/user-details/employee/'+value.user.EId+'/profilePhoto?size=t';
                                  value.user.profilePicUrl =  $sce.trustAsResourceUrl(profilePicUrl);
                              });
                              $scope.interviewDetails[interviewEId] = response.interview;
                     	} else {
                     		$scope.interviewDetails[interviewEId] = {};
                     		$scope.interviewCancelled = true;
                     	}

                         $scope.expanded[$scope.currentIndex] = true;
                         jvContextualLoadingService.hide($scope.widgetObject.widgetId);
                     }
                });
            }
    };


    $scope.dateClickCallback = function(data){
        $scope.collapseItem();
        $scope.selectedDate = $filter('date')(data.fullDate, 'yyyy-MM-dd');
        //before fetching data for a new date click make sure we fetch the page 0 HIRE-8382 NV
        $scope.requestObject.page = 0;
        $scope.fetchInterviewInformation($scope.requestObject.page,$scope.selectedDate);
    };

    //collapse Interview item
    $scope.collapseItem = function(){
        angular.forEach($scope.expanded,function(value,key){
            $scope.expanded[key] = false;
        });
        $scope.currentInterviewEId = null;
    };

}]);
